import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementBoreholeCreateMutation, useMeasurementBoreholeDeleteMutation, useMeasurementBoreholeUpdateMutation, useMeasurementBoreholeFindAllQuery } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useMeasurementBoreholeFindAllQuery(`?borehole_id=${id}`);
  const [measurementBoreholeCreate, measurementBoreholeCreateResult] = useMeasurementBoreholeCreateMutation();
  const [measurementBoreholeUpdate, measurementBoreholeUpdateResult] = useMeasurementBoreholeUpdateMutation();
  const [measurementBoreholeDelete, measurementBoreholeDeleteResult] = useMeasurementBoreholeDeleteMutation();

  const [measurementBorehole, setMeasurementBorehole] = useState<any>();

  const [contains_water, setContains_waterBoolean] = useState<boolean>(false);
  const [is_used, setIs_usedBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleandBoolean] = useState<boolean>(false);


  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  const {
    data: boreholeStateData,
    error: boreholeStateDataError,
    isFetching: isBoreholeStateDataFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_borehole_state`);

  useEffect(() => {

    if (measurementBorehole === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    setMeasurementList(data?.data);
    setMeaCount(measurementList?.length);

    const tempContains_water = measurementBorehole !== null ? measurementBorehole?.contains_water : false;
    const tempIs_used = measurementBorehole !== null ? measurementBorehole?.is_used : false;
    const tempIs_clean = measurementBorehole !== null ? measurementBorehole?.is_clean : false;

    setContains_waterBoolean(tempContains_water)
    setIs_usedBoolean(tempIs_used)
    setIs_cleandBoolean(tempIs_clean)

  }, [measurementBorehole, boreholeStateData, id, data?.data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: measurementBorehole?.id,
      borehole_id: measurementBorehole?.borehole_id,
      borehole_code: measurementBorehole?.borehole_code,
      measure_date: measurementBorehole?.measure_date,

      cmn_borehole_state: measurementBorehole?.cmn_borehole_state,
      water_spurt: measurementBorehole?.water_spurt,
      water_level_decrease: measurementBorehole?.water_level_decrease,
      water_stable_level: measurementBorehole?.water_stable_level,
      water_hydraulic_quality: measurementBorehole?.water_hydraulic_quality,
      refrain: measurementBorehole?.refrain,
      counter_detail: measurementBorehole?.counter_detail,
      equipment: measurementBorehole?.equipment,
      usage_information: measurementBorehole?.usage_information,

      sanitary_requirements: measurementBorehole?.sanitary_requirements,
      water_physical_quality: measurementBorehole?.water_physical_quality,
      is_counter: measurementBorehole?.is_counter,

      report_autor: measurementBorehole?.report_autor,
      report_code: measurementBorehole?.report_code,
      report_name: measurementBorehole?.report_name,
    },
    validationSchema: Yup.object({
      borehole_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      cmn_borehole_state: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_spurt: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("утга оруулна уу !"),
      water_level_decrease: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_hydraulic_quality: Yup.number().typeError("Тоон сонгоно уу").required("Утга оруулна уу !"),
      water_stable_level: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      refrain: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      counter_detail: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      equipment: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_physical_quality: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (measurementBorehole !== null) {
        const updateList = {
          id: measurementBorehole?.id,
          borehole_id: measurementBorehole?.borehole_id,
          borehole_code: values.borehole_code,
          measure_date: values.measure_date,
          cmn_borehole_state: values.cmn_borehole_state,
          water_spurt: values.water_spurt,
          water_level_decrease: values.water_level_decrease,
          water_hydraulic_quality: values.water_hydraulic_quality,
          water_stable_level: values.water_stable_level,
          refrain: values.refrain,
          counter_detail: values.counter_detail,
          report_autor: values.report_autor,
          report_code: values.report_code,
          report_name: values.report_name,
          equipment: values.equipment,
          usage_information: values.usage_information,
          sanitary_requirements: values.sanitary_requirements,
          water_physical_quality: values.water_physical_quality,

          is_counter: values.is_counter,
          contains_water: contains_water === undefined ? false : contains_water,
          is_used: is_used === undefined ? false : is_used,
          is_clean: is_clean === undefined ? false : is_clean,
        }
        measurementBoreholeUpdate(updateList);
      } else {
        const newList = {
          borehole_id: id,
          borehole_code: values["borehole_code"],
          measure_date: values["measure_date"],
          cmn_borehole_state: values["cmn_borehole_state"],
          water_spurt: values["water_spurt"],
          water_level_decrease: values["water_level_decrease"],
          water_hydraulic_quality: values["water_hydraulic_quality"],
          water_stable_level: values["water_stable_level"],
          refrain: values["refrain"],
          counter_detail: values["counter_detail"],
          report_autor: values["report_autor"],
          report_code: values["report_code"],
          report_name: values["report_name"],
          equipment: values["equipment"],
          usage_information: values["usage_information"],
          sanitary_requirements: values["sanitary_requirements"],
          water_physical_quality: values["water_physical_quality"],

          is_counter: values["is_counter"],
          contains_water: contains_water === undefined ? false : contains_water,
          is_used: is_used === undefined ? false : is_used,
          is_clean: is_clean === undefined ? false : is_clean,
        };
        measurementBoreholeCreate(newList)
      }
      // validation.resetForm();
    },
  });



  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const onClickDelete = () => {
    setDeleteModal(true);
  };
  const handleDeletejob = () => {
    if (measurementBorehole) {
      measurementBoreholeDelete(measurementBorehole.id);
      setDeleteModal(false);
    }
    setMeasurementBorehole(null);
    setIs_newCreated(true)
  };
  return (
    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label me-3"
              onClick={() => {
                validation.resetForm();
                setMeasurementBorehole(null);
                setContains_waterBoolean(false)
                setIs_usedBoolean(false);
                setIs_cleandBoolean(false)
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

            {
              is_newCreated === false && measurementBorehole !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={measurementBorehole?.report_name}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementBorehole(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэлийн дугаар </Label>
                      <Input
                        name="borehole_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.borehole_code || ""}
                        invalid={
                          validation.touched.borehole_code &&
                            validation.errors.borehole_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.borehole_code &&
                        validation.errors.borehole_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.borehole_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн зэрэг </Label>
                      <Input
                        name="water_hydraulic_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_hydraulic_quality || ""}
                        invalid={
                          validation.touched.water_hydraulic_quality &&
                            validation.errors.water_hydraulic_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_hydraulic_quality &&
                        validation.errors.water_hydraulic_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_hydraulic_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ажиглалтын хугацааны үр дүн </Label>
                      <Input
                        name="counter_detail"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.counter_detail || ""}
                        invalid={
                          validation.touched.counter_detail &&
                            validation.errors.counter_detail
                            ? true
                            : false
                        }
                      />
                      {validation.touched.counter_detail &&
                        validation.errors.counter_detail ? (
                        <FormFeedback type="invalid">
                          {validation.errors.counter_detail}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн судалгааны үе шат </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тоолууртай эсэх </Label>
                      <Input
                        name="is_counter"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.is_counter || ""}
                        invalid={
                          validation.touched.is_counter &&
                            validation.errors.is_counter
                            ? true
                            : false
                        }
                      >
                        <option value="">Тодорхойгүй</option>
                        <option value="false">Байхгүй</option>
                        <option value="true">Байгаа</option>
                      </Input>
                      {validation.touched.is_counter &&
                        validation.errors.is_counter ? (
                        <FormFeedback type="invalid">
                          {validation.errors.is_counter}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цооногийн төлөв </Label>
                      <Input
                        name="cmn_borehole_state"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cmn_borehole_state || ""}
                        invalid={
                          validation.touched.cmn_borehole_state &&
                            validation.errors.cmn_borehole_state
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>
                        {
                          boreholeStateData?.data.map((item, index) => (
                            <option key={index} value={item.id}> {item.name} </option>
                          ))
                        }
                      </Input>
                      {validation.touched.cmn_borehole_state &&
                        validation.errors.cmn_borehole_state ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cmn_borehole_state}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн фондын бүртгэлийн дугаар   </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц тооцсон арга </Label>
                      <Input
                        name="water_stable_level"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_stable_level || ""}
                        invalid={
                          validation.touched.water_stable_level &&
                            validation.errors.water_stable_level
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_stable_level &&
                        validation.errors.water_stable_level ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_stable_level}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц ашиглалт (м<sup>3</sup> хоног) </Label>
                      <Input
                        name="equipment"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.equipment || ""}
                        invalid={
                          validation.touched.equipment &&
                            validation.errors.equipment
                            ? true
                            : false
                        }
                      />
                      {validation.touched.equipment &&
                        validation.errors.equipment ? (
                        <FormFeedback type="invalid">
                          {validation.errors.equipment}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц баялаг(м<sup>3</sup>хоног) </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Устай эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setContains_waterBoolean(!contains_water);
                        }}
                        checked={contains_water}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Судалгааны тайлангийн нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_usedBoolean(!is_used);
                        }}
                        checked={is_used}
                      />
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ордын нийт талбай (км<sup>2</sup>)</Label>
                      <Input
                        name="water_level_decrease"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_level_decrease || ""}
                        invalid={
                          validation.touched.water_level_decrease &&
                            validation.errors.water_level_decrease
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_level_decrease &&
                        validation.errors.water_level_decrease ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_level_decrease}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц тооцсон бүдүүвч схем  </Label>
                      <Input
                        name="refrain"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.refrain || ""}
                        invalid={
                          validation.touched.refrain &&
                            validation.errors.refrain
                            ? true
                            : false
                        }
                      />
                      {validation.touched.refrain &&
                        validation.errors.refrain ? (
                        <FormFeedback type="invalid">
                          {validation.errors.refrain}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн структур </Label>
                      <Input
                        name="water_physical_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_physical_quality || ""}
                        invalid={
                          validation.touched.water_physical_quality &&
                            validation.errors.water_physical_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_physical_quality &&
                        validation.errors.water_physical_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_physical_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасах эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleandBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр,эрүүл ахуйн шаардлага хангалт </Label>
                      <Input
                        name="water_spurt"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_spurt || ""}
                        invalid={
                          validation.touched.water_spurt &&
                            validation.errors.water_spurt
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_spurt &&
                        validation.errors.water_spurt ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_spurt}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан зохиогчийн нэр  </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={12} className="d-flex justify-content-around mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>

      </Row>

    </>
  )
}

export default Measurement;